module.exports = __webpack_public_path__ + "img/Mobile-Devices-Green-Hue.ff50c79e.jpg";